import { colors } from "widgets/utils";

import { REGION_DRAG_INDICATOR_HOVER_WIDTH } from "../../settings.ts";
import type { SelectionRange } from "../../types.ts";
import { alignToLeftPixelGrid } from "../../utils/graphics/align-to-pixel-grid.ts";

export function rangeSelectionBarRenderer(
  ctx: CanvasRenderingContext2D | null,
  selectedRange: SelectionRange | undefined,
  basePerPixel: number,
  scrollX: number,
  isStartHovered: boolean,
  isStopHovered: boolean,
) {
  if (ctx && selectedRange) {
    const startX = alignToLeftPixelGrid(selectedRange.start / basePerPixel - scrollX);
    const stopX = alignToLeftPixelGrid(selectedRange.stop / basePerPixel - scrollX);

    ctx.save();

    ctx.globalAlpha = 1;
    ctx.strokeStyle = colors.selectStroke;

    ctx.lineWidth = isStartHovered ? REGION_DRAG_INDICATOR_HOVER_WIDTH : 1;
    ctx.beginPath();
    ctx.moveTo(startX, REGION_DRAG_INDICATOR_HOVER_WIDTH / 2);
    ctx.lineTo(startX, ctx.canvas.height);
    ctx.closePath();
    ctx.stroke();

    ctx.lineWidth = isStopHovered ? REGION_DRAG_INDICATOR_HOVER_WIDTH : 1;
    ctx.beginPath();
    ctx.moveTo(stopX, 0);
    ctx.lineTo(stopX, ctx.canvas.height);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
  }
}
